import type { Criterion, PresentationType } from './types';
import { CRITERIA } from './criteria';

/** A named set of scoring criteria, applied to one or more presentation categories. */
export interface Rubric {
  id: string;
  name: string;
  /** Categories this rubric scores. Empty = catch-all (applies to every category). */
  categories: string[];
  criteria: Criterion[];
}

/**
 * Pick the criteria for a presentation given the year's rubrics.
 * 1. a rubric explicitly tagged with the presentation's category (case-insensitive),
 * 2. else a catch-all rubric (no categories),
 * 3. else the built-in default for the type (so scoring still works before rubrics are configured).
 */
export function resolveCriteria(
  rubrics: Rubric[],
  category: string | null | undefined,
  type: PresentationType,
): Criterion[] {
  const cat = (category ?? '').trim().toLowerCase();
  if (cat) {
    const tagged = rubrics.find((r) => r.categories.some((c) => c.trim().toLowerCase() === cat));
    if (tagged) return tagged.criteria;
  }
  const catchAll = rubrics.find((r) => r.categories.length === 0);
  if (catchAll) return catchAll.criteria;
  return CRITERIA[type] ?? CRITERIA.oral;
}
